﻿import "./favorite-list-button.svelte";
import "./favorite-toggle.svelte";

if (document.querySelector("favorite-list") != null) {
	import("./favorite-list.svelte");
}
